import { CryptoRewardsCurrenciesMarketDataResponse } from 'components/features/rewards/rewardsPane/types/apiResponses'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'

export class CurrenciesMetaGetMarketDataRequestAction extends (
  createRequestAction<'API_REQUEST_GET_CURRENCIES_MARKET_DATA', void, CryptoRewardsCurrenciesMarketDataResponse['items']>('API_REQUEST_GET_CURRENCIES_MARKET_DATA')
) {}

export type CurrenciesStatisticsReducerActions =
  | typeof CurrenciesMetaGetMarketDataRequestAction.Type

